import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconEmptyContentColor from './icon-empty-content-color.vue';

const IconEmptyContentColor = Object.assign(_IconEmptyContentColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconEmptyContentColor.name, _IconEmptyContentColor);
  }
});

export default IconEmptyContentColor;
